import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const CerezPage = () => {
  useEffect(() => {
    document.title = 'Çerez Politikası - İzmir Tente Tamir';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir Tente Tamir çerez politikası. Web sitemizde kullanılan çerezler ve amaçları hakkında bilgilendirme.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Çerez Politikası
          </h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6 leading-relaxed">
              İzmir Tente Tamir olarak, web sitemizde kullanıcı deneyimini iyileştirmek ve hizmetlerimizi geliştirmek amacıyla çerezler kullanmaktayız. Bu politika, çerezlerin ne olduğunu, nasıl kullanıldığını ve çerez tercihlerinizi nasıl yönetebileceğinizi açıklamaktadır.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">1. Çerez Nedir?</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Çerezler, bir web sitesini ziyaret ettiğinizde cihazınıza (bilgisayar, tablet veya mobil cihaz) kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin düzgün çalışmasını sağlamak, kullanıcı deneyimini iyileştirmek ve site performansını analiz etmek için kullanılır.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">2. Çerez Türleri</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">2.1. Zorunlu Çerezler</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Bu çerezler, web sitesinin temel işlevlerini yerine getirmesi için gereklidir. Bu çerezler olmadan web sitesi düzgün çalışmaz.
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Oturum yönetimi</li>
              <li>Güvenlik</li>
              <li>Temel site işlevselliği</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">2.2. Performans Çerezleri</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Bu çerezler, web sitesinin nasıl kullanıldığına dair bilgi toplar. Bu bilgiler, site performansını iyileştirmek için kullanılır.
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Sayfa görüntüleme sayıları</li>
              <li>Ziyaret süresi</li>
              <li>Hata raporları</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">2.3. İşlevsellik Çerezleri</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Bu çerezler, tercihlerinizi hatırlamak ve size daha kişiselleştirilmiş bir deneyim sunmak için kullanılır.
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Dil tercihleri</li>
              <li>Bölge ayarları</li>
              <li>Kullanıcı tercihleri</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">3. Çerezlerin Kullanım Amaçları</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Web sitemizde çerezleri aşağıdaki amaçlarla kullanmaktayız:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li><strong>Web Sitesi İşlevselliği:</strong> Sitenin düzgün çalışmasını sağlamak</li>
              <li><strong>Güvenlik:</strong> Güvenlik önlemlerini uygulamak ve dolandırıcılığı önlemek</li>
              <li><strong>Performans İzleme:</strong> Site performansını analiz etmek ve iyileştirmek</li>
              <li><strong>Kullanıcı Deneyimi:</strong> Tercihlerinizi hatırlamak ve size özelleştirilmiş içerik sunmak</li>
              <li><strong>İstatistiksel Analiz:</strong> Ziyaretçi davranışlarını anlamak ve hizmetlerimizi geliştirmek</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">4. Kullandığımız Çerezler</h2>
            
            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">4.1. Birinci Taraf Çerezler</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Doğrudan web sitemiz tarafından oluşturulan çerezlerdir:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Oturum çerezleri</li>
              <li>Tercih çerezleri</li>
              <li>Güvenlik çerezleri</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">4.2. Üçüncü Taraf Çerezler</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Hizmet sağlayıcılarımız tarafından oluşturulan çerezlerdir:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Analitik çerezler (örn. Google Analytics)</li>
              <li>Harita hizmetleri (örn. Google Maps)</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">5. Çerez Tercihlerinizi Yönetme</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Çerez tercihlerinizi aşağıdaki yöntemlerle yönetebilirsiniz:
            </p>

            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">5.1. Tarayıcı Ayarları</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Çoğu web tarayıcısı, çerezleri otomatik olarak kabul edecek şekilde ayarlanmıştır. Tarayıcı ayarlarınızdan çerezleri engelleyebilir veya silebilirsiniz:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li><strong>Chrome:</strong> Ayarlar &gt; Gizlilik ve güvenlik &gt; Çerezler</li>
              <li><strong>Firefox:</strong> Ayarlar &gt; Gizlilik ve Güvenlik &gt; Çerezler ve Site Verileri</li>
              <li><strong>Safari:</strong> Tercihler &gt; Gizlilik &gt; Çerezler</li>
              <li><strong>Edge:</strong> Ayarlar &gt; Gizlilik, arama ve hizmetler &gt; Çerezler</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">5.2. Çerez Onay Paneli</h3>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Web sitemizi ilk ziyaret ettiğinizde görünen çerez onay panelinden tercihlerinizi belirtebilirsiniz. İstediğiniz zaman tercihlerinizi değiştirebilirsiniz.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">6. Çerezleri Reddetmenin Sonuçları</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Çerezleri reddetmeniz veya silmeniz durumunda, web sitesinin bazı özellikleri düzgün çalışmayabilir. Örneğin, tercihleriniz hatırlanmayabilir veya bazı sayfalar doğru şekilde yüklenmeyebilir.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">7. Çerez Saklama Süreleri</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Çerezler, türlerine göre farklı sürelerde saklanır:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li><strong>Oturum Çerezleri:</strong> Tarayıcı kapatıldığında silinir</li>
              <li><strong>Kalıcı Çerezler:</strong> Belirli bir süre (genellikle 1-12 ay) saklanır</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">8. Gizlilik ve Güvenlik</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Çerezler aracılığıyla toplanan bilgiler, <Link to="/kvkk" className="text-gray-900 font-medium underline cursor-pointer">KVKK Politikamız</Link> kapsamında korunmaktadır. Kişisel verilerinizin güvenliği için gerekli teknik ve idari tedbirleri almaktayız.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">9. Politika Güncellemeleri</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Bu çerez politikası, yasal düzenlemelerdeki değişiklikler veya iş süreçlerindeki güncellemeler doğrultusunda revize edilebilir. Güncel versiyona web sitemizden ulaşabilirsiniz.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-8">10. İletişim</h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              Çerez politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>Telefon: 0551 372 35 12</li>
              <li>Adres: Karabağlar / İzmir</li>
            </ul>

            <p className="text-gray-700 mt-8 text-sm">
              <strong>Son Güncelleme:</strong> 01.01.2025
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center text-sm font-medium text-gray-900 hover:text-gray-700 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Anasayfaya Dön
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CerezPage;
